/**
 * Conditional logger that only outputs to console in development environments.
 * In production, logs are suppressed to maintain privacy focus.
 * 
 * Uses Vite's built-in environment variables.
 */
export const isDevelopment = import.meta.env.DEV;

/**
 * Conditionally log to console if in development environment
 * @param {...any} args - Arguments to pass to console.log
 */
export const conditionalLog = (...args) => {
    if (isDevelopment) {
        console.log(...args);
    }
};

/**
 * Conditionally log errors to console if in development environment
 * @param {...any} args - Arguments to pass to console.error
 */
export const conditionalError = (...args) => {
    if (isDevelopment) {
        console.error(...args);
    }
};
